import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  addNewTimeEntryNonBillableType,
  addNewTimeEntryNonBillableTypeSuccess,
  deleteTimeEntryNonBillableType,
  deleteTimeEntryNonBillableTypeSuccess,
  getTimeEntryTypeList,
  updateTimeEntryNonBillableType,
  updateTimeEntryNonBillableTypeSuccess,
} from "../../../../store/timeEntries/action";
export default function TimeEntrySettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  // The panel has a single dataset; the guards below are kept as-is.
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const { timeEntryTypesAPI } = useSelector((state) => ({
    timeEntryTypesAPI:
      state.TimeEntries.timeEntryTypes?.timeentrytypeunbillable_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addNewTimeEntryNonBillableType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = timeEntryTypesAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [timeEntryTypesAPI, activeTab]);

  useEffect(() => {
    dispatch(getTimeEntryTypeList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteTimeEntryNonBillableType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateTimeEntryNonBillableType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Effects
  const {
    addNewNonBillableTypeSuccessAPI,
    deleteNonBillableTypeSuccessAPI,
    updateNonBillableTypeSuccessAPI,
  } = useSelector((state) => ({
    addNewNonBillableTypeSuccessAPI:
      state.TimeEntries.addNewNonBillableTypeSuccess,
    deleteNonBillableTypeSuccessAPI:
      state.TimeEntries.deleteNonBillableTypeSuccess,
    updateNonBillableTypeSuccessAPI:
      state.TimeEntries.updateNonBillableTypeSuccess,
  }));

  // Add new billable type
  useEffect(() => {
    if (isEmpty(addNewNonBillableTypeSuccessAPI)) return;
    if (addNewNonBillableTypeSuccessAPI?.status === 200) {
      toast.success(addNewNonBillableTypeSuccessAPI?.message);
      dispatch(getTimeEntryTypeList());
    } else {
      toast.error(addNewNonBillableTypeSuccessAPI?.message);
    }
    dispatch(addNewTimeEntryNonBillableTypeSuccess([]));
  }, [addNewNonBillableTypeSuccessAPI]);

  // Delete billable type
  useEffect(() => {
    if (isEmpty(deleteNonBillableTypeSuccessAPI)) return;
    if (deleteNonBillableTypeSuccessAPI?.status === 200) {
      toast.success(deleteNonBillableTypeSuccessAPI?.message);
      dispatch(getTimeEntryTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteNonBillableTypeSuccessAPI?.message);
    }
    dispatch(deleteTimeEntryNonBillableTypeSuccess([]));
  }, [deleteNonBillableTypeSuccessAPI]);

  // Update billable type
  useEffect(() => {
    if (isEmpty(updateNonBillableTypeSuccessAPI)) return;
    if (updateNonBillableTypeSuccessAPI?.status === 200) {
      toast.success(updateNonBillableTypeSuccessAPI?.message);
      dispatch(getTimeEntryTypeList());
    } else {
      toast.error(updateNonBillableTypeSuccessAPI?.message);
    }
    dispatch(updateTimeEntryNonBillableTypeSuccess([]));
  }, [updateNonBillableTypeSuccessAPI]);
  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      {/* Single-tab panel: SettingsPanel renders no strip for one tab, so the
          old Nav + the <h5> that echoed it are both gone. */}
      <SettingsPanel
        title="Time Entry Settings"
        description="Non-billable time entry types staff can log against."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
        />
      </SettingsPanel>
    </>
  );
}
